/**
 * Homepage product card quantity controls.
 */
(function () {
  'use strict';

  function bindCard(card) {
    var qtyWrap = card.querySelector('[data-home-qty]');
    var valEl = card.querySelector('[data-home-qty-val]');
    var input = card.querySelector('[data-home-qty-input]');
    var minus = card.querySelector('[data-home-qty-minus]');
    var plus = card.querySelector('[data-home-qty-plus]');
    if (!qtyWrap || !valEl) return;

    var qty = 1;

    function sync() {
      valEl.textContent = String(qty);
      if (input) input.value = String(qty);
      if (minus) minus.disabled = qty <= 1;
      if (plus) plus.disabled = qty >= 99;
    }

    if (minus) {
      minus.addEventListener('click', function () {
        qty = Math.max(1, qty - 1);
        sync();
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        qty = Math.min(99, qty + 1);
        sync();
      });
    }

    sync();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-home-card]').forEach(bindCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) init(event.target);
  });
})();
